import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import playImg from '../../../assets/play.svg';

export default function VideoPlayer(props) {
  const {
    size = 420,
    imageUrl,
    videoUrl,
    setVideoModalState
  } = props;

  const [isPlaying, setIsPlaying] = useState(false);
  const [pause, setPause] = useState(false);
  const xUrl = imageUrl || props.url;

  const videoRef = useRef();

  useEffect(() => {
    if (videoRef.current) {
      if (pause == false) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [pause]);

  if (videoUrl == undefined) {
    return null;
  }

  return (
    <Wrapper style={{ width: size, height: size }}>

      <InnerPlaceholder style={{ width: size, height: size }}>

        {isPlaying == true ? null :
          <Photo src={xUrl} onClick={() => setVideoModalState ? setVideoModalState({ isOpen: true, videoUrl, pictureUrl: xUrl }) : setIsPlaying(true)}
          >
            <PlayImage alt={'play'} src={playImg}/>
          </Photo>
        }

        {isPlaying == false ? null :
          <Video ref={videoRef} autoPlay={true}
            visible={isPlaying}
            onClick={() => setPause(!pause)} 
            onEnded={() => setIsPlaying(false)}
          >
            <source src={videoUrl} type="video/mp4"/>
          </Video>
        }

      </InnerPlaceholder>

    </Wrapper>
  );
}

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  box-sizing: border-box;
  border-radius: 12px;
  cursor: pointer;
`;

const Wrapper = styled.div`
  padding: 5px;
  border-radius: 12px;
`;

const Photo = styled.div`
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  background-image: url("${props => props.src}");
  border-radius: 12px;

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const PlayImage = styled.img`
  height: 90px;
  opacity: 0.9;

  :hover {
    opacity: 1;
  }

  @media (max-width: 400px) {
    height: 50px;
  }
`;

const InnerPlaceholder = styled.div`
  background: black;
  border-radius: 12px;
`;